export enum PendencyType {
  COMPANY_DATA = {
    code: 'COMPANY_DATA',
    title: 'PENDENCY.COMPANY_DATA',
    description: 'PENDENCY.COMPANY_DATA_DESCRIPTION',
    order: 1,
    icon: 'document',
    iconiOS: 'ios-document-outline',
    optional: false,
  } as any,
  GEOLOCATION = {
    code: 'GEOLOCATION',
    title: 'PENDENCY.GEOLOCATION',
    description: 'PENDENCY.GEOLOCATION_DESCRIPTION',
    order: 2,
    icon: 'pin',
    iconiOS: 'ios-pin-outline',
    optional: false,
  } as any,
  BUSINESS_HOURS = {
    code: 'BUSINESS_HOURS',
    title: 'PENDENCY.BUSINESS_HOURS',
    description: 'PENDENCY.BUSINESS_HOURS_DESCRIPTION',
    order: 3,
    icon: 'time',
    iconiOS: 'ios-time-outline',
    optional: false,
  } as any,
  BUSINESS_TYPE = {
    code: 'BUSINESS_TYPE',
    title: 'PENDENCY.BUSINESS_TYPE',
    description: 'PENDENCY.BUSINESS_TYPE_DESCRIPTION',
    order: 4,
    icon: 'briefcase',
    iconiOS: 'ios-briefcase-outline',
    optional: false,
  } as any,
  PRODUCTS = {
    code: 'PRODUCTS',
    title: 'PENDENCY.PRODUCTS',
    description: 'PENDENCY.PRODUCTS_DESCRIPTION',
    order: 5,
    icon: 'book',
    iconiOS: 'ios-book-outline',
    optional: true,
  } as any,
  TABLES = {
    code: 'TABLES',
    title: 'PENDENCY.TABLES',
    description: 'PENDENCY.TABLES_DESCRIPTION',
    order: 6,
    icon: 'custom-table',
    iconiOS: 'custom-table',
    optional: false,
  } as any,
  RESERVATION = {
    code: 'RESERVATION',
    title: 'PENDENCY.RESERVATION',
    description: 'PENDENCY.RESERVATION_DESCRIPTION',
    order: 7,
    icon: 'calendar',
    iconiOS: 'ios-calendar-outline',
    optional: true,
  } as any,
  BANK_ACCOUNT = {
    code: 'BANK_ACCOUNT',
    title: 'PENDENCY.BANK_ACCOUNT',
    description: 'PENDENCY.BANK_ACCOUNT_DESCRIPTION',
    order: 999,
    icon: 'cash',
    iconiOS: 'ios-cash-outline',
    optional: false,
  } as any,
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/pendency-type.enum.ts